import { createContext } from "react";
import { IDetailsReportEditionContext } from "./DetailsReportEditionContextInterface";

export const initialState: IDetailsReportEditionContext = {
    edit: [],
    setEdit: () => {},
};

export const DetailsReportEditionContext = createContext(initialState);
